import dayjs from 'dayjs';

// O backend devolve datas de bloqueio em ISO (YYYY-MM-DDTHH:mm:ss), mas o envio
// é feito em DD/MM/YYYY HH:mm. Parseamos os formatos DD/MM/YYYY de forma estrita
// e, se não baterem, caímos para o parse padrão do dayjs (ISO). Retorna null
// quando o valor é vazio.
export const parseBlockDateTime = (value) => {
  if (!value) return null;
  const parsed = dayjs(value, ['DD/MM/YYYY HH:mm:ss', 'DD/MM/YYYY HH:mm'], true);
  return parsed.isValid() ? parsed : dayjs(value);
};

export const BLOCK_COLOR = '#6c757d';

// Converte um bloqueio de agenda em um evento do FullCalendar.
export const toBlockEvent = (block) => ({
  title: block.reason || 'Bloqueado',
  start: parseBlockDateTime(block.startDateTime).toDate(),
  end: parseBlockDateTime(block.endDateTime).toDate(),
  backgroundColor: BLOCK_COLOR,
  borderColor: BLOCK_COLOR,
  extendedProps: {
    blockId: block.id,
    isBlock: true,
  },
});
